import instance from 'api';
import { IAdminPosition } from './interfaces';

export const getAdminPositions = () => {
  return instance()
    .post<IAdminPosition[]>('/dictionary/adminPositions')
    .then((response) => response.data);
};
